import { LoaderCircle } from 'lucide-react'

import { formatCount, formatDuration, formatPercent, formatValue } from './model'

import styles from './AttributionObservabilityPage.module.scss'

import Button from '@/components/Button'

const LoadingState = ({ label, skeleton = false }: { label: string; skeleton?: boolean }) => (
  <div className={skeleton ? styles.loadingPanel : styles.loadingIndicator} role="status" aria-live="polite">
    <span className={styles.loadingIndicator}>
      <LoaderCircle size={18} className={styles.loadingSpinner} aria-hidden="true" />
      {label}
    </span>
    {skeleton && (
      <div className={styles.loadingSkeleton} aria-hidden="true">
        <span />
        <span />
        <span />
        <span />
      </div>
    )}
  </div>
)

const ErrorState = ({ onRetry }: { onRetry: () => void }) => (
  <div className={styles.error} role="alert">
    <span>Could not load attribution data.</span>
    <Button title="Retry" type="light" onClick={onRetry} />
  </div>
)

const StaleNotice = ({ onRetry }: { onRetry: () => void }) => (
  <p className={styles.staleNotice} role="status">
    Showing saved results. Refresh failed.{' '}
    <button type="button" onClick={onRetry}>
      Retry
    </button>
  </p>
)

const Ratio = ({
  numerator,
  denominator,
  unit = 'speakers',
  status,
}: {
  numerator: number | null
  denominator: number | null
  unit?: 'speakers' | 'words' | 'duration'
  status?: string
}) => (
  <span className={styles.ratio}>
    <strong>
      {status === 'not_applicable'
        ? 'Not applicable'
        : status === 'unknown'
          ? 'Not measured'
          : status !== undefined && status !== 'measured'
            ? formatValue(status)
            : formatPercent(numerator, denominator)}
    </strong>
    {numerator !== null && denominator !== null && (status === undefined || status === 'measured') && (
      <small>
        {unit === 'duration'
          ? `${formatDuration(numerator)} / ${formatDuration(denominator)}`
          : `${formatCount(numerator)} / ${formatCount(denominator)} ${unit}`}
      </small>
    )}
  </span>
)

export { ErrorState, LoadingState, Ratio, StaleNotice }
